module.exports = __webpack_public_path__ + "static/media/mkf-logo.1eb86785.png";